<template>
    <div class="container">
        <div class="title">Error</div>
        <div class="body">
            <div class="message">{{ props.message }}</div>
            <div v-if="props.details" class="show-details">
                <span class="show-details-link" @click="showDetails = !showDetails">
                    {{ showDetails ? 'Hide Details' : 'Show Details' }}
                </span>
            </div>
            <div v-if="showDetails" class="details">{{ props.details }}</div>
        </div>
        <div class="footer">
            <input type="button" value="Copy Info" class="button button-secondary error-copy" @click="copyErrorData()">
            <input type="button" value="Close" class="button error-button" @click="close()" />
        </div>
    </div>
</template>

<script setup>
    import { defineProps, defineEmits, ref, onMounted } from 'vue';
    import { Modal as ModalLib } from 'jenesius-vue-modal';

    const props = defineProps({
        message: {
            type: String,
            required: true
        },

        details: {
            type: String,
            default: undefined
        }
    });
    
    const emit = defineEmits([ModalLib.EVENT_PROMPT]);

    const showDetails = ref(false);

    onMounted(() => {
        console.error(`Error component message: '${props.message}', details: '${props.details}'`);
    });

    function copyErrorData(){
        navigator.clipboard.writeText(`${props.message}\n\n${props.details}`);
    }

    async function close() {
        emit(ModalLib.EVENT_PROMPT, true);
    }
</script>

<style scoped>
    .container {
        display: flex;
        flex-direction: column;
        position: relative;
        max-height: 100%;
        width: 500px;
        overflow-y: scroll;
        background-color: white;
        border-radius: 7px;
        overflow: hidden; /* otherwise square corners of title box will show behind rounded coners of parent */
    }

    .title {
        font-size: 20px;
        border-bottom: solid #d8d6d6 1px;
        padding: 15px;
        color: white;
        background-color: #cc0000;
    }

    .body {
        border-bottom: solid #c7c6c6 1px;
        padding: 25px;
    }

    .footer {
        display: flex;
        flex-direction: row;
        justify-content: right;
        padding: 15px;
    }

    .error-button {
        margin-left: 10px;
    }

    .message {
        margin-bottom: 20px;
    }

    .show-details {
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: end;
        color: #11a69c;
    }

    .show-details-link {
        color: #11a69c;
        cursor: pointer;
    }

    .details-copy {
        cursor: pointer;
    }

    .details {
        margin-top: 20px;
        font-family: 'Courier New', Courier, monospace;
        font-size: 11pt;
        overflow: scroll;
    }

    .error-copy:active {
        color: white;
        background-color: #11a69c;
    }
</style>
